export const apiEndpoints = {
  // Auth endpoints
  login: "/admin/login",
  refreshToken: "/admin/refreshToken",
  forgotPassword: "/admin/forgotPassword",
  updatePasswordByOTP: "/admin/updatePasswordByOTP",
  getProfileInfo: "/admin/getProfileInfo",
  updateAdminProfile: "/admin/updateAdminProfile",
  updatePasswordByCurrentPassword: "/admin/updatePasswordByCurrentPassword",

  // Location endpoints
  getLocations: "/location/getAll",

  // Ship endpoints
  getShip: "/ship/getAll",

  // Airport endpoints
  getAirport: "/airport/getAll",

  // EstablishmentType endpoints
  getEstablishmentType: "/establishment-type/getAll",

  // EstablishmentTypeQuestion endpoints
  getEstablishmentTypeQuestion: "/establishment-type-question/getAll",

  // Customer List
  getCustomerList: "/lost/getCustomerList",
  sendCustomerReminder: "/lost/sendCustomerReminder",

  // Carrier endpoints
  getCarriers: "/carrier/getAll",

  // PricingPlan endpoints
  features: {
    getAll: "/feature/getAll",
    create: "/feature/create",
    update: "/feature/update",
    delete: "/feature/delete",
    updateOrder: "/feature/updateOrder",
  },

  // Features endpoints
  pricingPlan: {
    getAll: "/pricing-plan/getAll",
    create: "/pricing-plan/create",
    update: "/pricing-plan/update",
    delete: "/pricing-plan/delete",
  },

  // Category endpoints
  category: {
    getAll: "/category/getAll",
    create: "/category/create",
    update: "/category/update",
    delete: "/category/delete",
  },

  // Subcategory endpoints
  subcategory: {
    getAll: "/subcategory/getAll",
    create: "/subcategory/create",
    update: "/subcategory/update",
    delete: "/subcategory/delete",
  },

  // Subcategory endpoints
  question: {
    getAll: "/question/getAll",
    create: "/question/create",
    update: "/question/update",
    delete: "/question/delete",
  },

  // Delete reason endpoints
  deleteReason: {
    getAll: "/discard-reasons/getAll",
    create: "/discard-reasons/create",
    update: "/discard-reasons/update",
    delete: "/discard-reasons/delete",
  },

  // Found item discard reason endpoints
  foundItemDiscardReason: {
    getAll: "/found-item-discard-reasons/getAll",
    create: "/found-item-discard-reasons/create",
    update: "/found-item-discard-reasons/update",
    delete: "/found-item-discard-reasons/delete",
  },

  // Update Lost Report Details
  reportDetail: {
    getLostItemInfoByTrackingId: "/lost/getLostItemInfoByTrackingId",
    updateUserDetail: "/lost/updateUserDetail",
    updateItemDetail: "/lost/updateItemDetail",
    updateLocationDetail: "/lost/updateLocationDetail",
    uploadDocument: "/lost/uploadLostDocument",
    deleteDocument: "/lost/deleteLostDocument",
    updateLostItemStatus: "/lost/updateLostItemStatus",
    updateUrgentStatus: "/lost/updateUrgentStatus",
    updateLostDate: "/lost/updateLostDate",
    getLostItemInfoByVersion: "/lost/getLostItemInfoByVersion",
    updateLFNotifications: "/lost/updateLFNotifications",
    updateLFNotificationComment: "/lost/updateLFNotificationComment",
  },

  // User configuration
  user: {
    getAllPermissionConfig: "/permission/getAllPermissionConfig",
    createRole: "/permission/createRole",
    updateRole: "/permission/updateRole",
    getAllRole: "/permission/getAllRole",
    deleteRole: "/permission/deleteRole",
    createAdminUser: "/admin/createAdminUser",
    getAllAdminUser: "/admin/getAllAdminUser",
    updateAdminUser: "/admin/updateAdminUser",
    deleteAdminUser: "/admin/deleteAdminUser",
    getAllCaseManager: "/admin/getAllCaseManager",
  },
  permission: {
    create: "/permission/create",
    update: "/permission/update",
    updateOrder: "/permission/updateOrder",
    delete: "/permission/delete",
  },
  lost: {
    getLostItemInfoByStatus: "/lost/getLostItemInfoByStatus",
    getLostItemInfoByStatusBatch: "/lost/getLostItemInfoByStatusBatch",
    getConversionTracking: "/lost/getConversionTracking",
    getConversionTrackingStats: "/lost/getConversionTrackingStats",
    getClaimsForTestToggle: "/lost/getClaimsForTestToggle",
    toggleTestClaim: "/lost/toggleTestClaim",
    toggleEmailCommunication: "/lost/toggleEmailCommunication",
    linkFoundItemWithLostItem: "/lost/linkFoundItemWithLostItem",
    deleteLostItem: "/lost/deleteLostItem",
    getDeletedLostInfo: "/lost/getDeletedLostInfo",
    updateCaseManager: "/lost/updateCaseManager",
    uploadShippingLabel: "/lost/uploadShippingLabel",
    uploadAdditionalDoc: "/lost/uploadAdditionalDoc",
    updateTrackingNumber: "/lost/updateTrackingNumber",
    uploadShippingProof: "/lost/uploadShippingProof",
    generateServiceCompletion: "/lost/generateServiceCompletion",
  },

  // Found items
  found: {
    getAll: "/found/getAll",
    getFoundItemInfoByStatus: "/found/getFoundItemInfoByStatus",
    updateItemStatus: "/found/updateFoundItemStatus",
    sendFoundReport: "/found/sendFoundRequest",
    getPrematchedFoundItems: "/found/getPrematchedFoundItems",
    getFoundItemByItemNumber: "/found/getFoundItemByItemNumber",
    updateFoundItem: "/found/updateFoundItem",
    getFoundItemInfoByVersion: "/found/getFoundItemInfoByVersion",
    deleteFoundItem: "/found/deleteFoundItem",
    sendPaymentRequest: "/found/sendPaymentRequest",
    updateCaseManager: "/found/updateCaseManager",
    getDeletedFoundItem: "/found/getDeletedFoundItem",
  },

  userRequest: {
    passPendingRequest: "/user-request/passPendingRequest",
    rejectPendingRequest: "/user-request/rejectPendingRequest",
    updateLostItemByAdmin: "/user-request/updateLostItemByAdmin",
    deleteLostRequest: "/user-request/deleteLostRequest",
    sendLostReport: "/lost/sendLostRequest"
  },

  // Ship endpoints
  ship: {
    getAll: "/ship/getAll",
    create: "/ship/create",
    update: "/ship/update",
    delete: "/ship/delete",
  },

  airport: {
    getAll: "/airport/getAll",
    create: "/airport/create",
    update: "/airport/update",
    delete: "/airport/delete",
  },

  establishmentType: {
    getAll: "/establishment-type/getAll",
    create: "/establishment-type/create",
    update: "/establishment-type/update",
    delete: "/establishment-type/delete",
    updateOrder: "/establishment-type/updateOrder",
  },

  establishmentLocation: {
    getAll: "/establishment-location/getAll",
    get: "/establishment-location/get",
    create: "/establishment-location/create",
    update: "/establishment-location/update",
    delete: "/establishment-location/delete",
    claimCount: "/establishment-location/claim-count",
    updateOrder: "/establishment-location/updateOrder",
    updateFooterOrder: "/establishment-location/updateFooterOrder",
  },

  place: {
    getAll: "/place/getAll",
    get: "/place/get",
    create: "/place/create",
    update: "/place/update",
    delete: "/place/delete",
    updateOrder: "/place/updateOrder",
  },

  contact: {
    getAll: "/contact/getAll",
    get: "/contact/get",
    create: "/contact/create",
    update: "/contact/update",
    delete: "/contact/delete",
    updateOrder: "/contact/updateOrder",
    setPrimary: "/contact/setPrimary",
  },

  establishmentTypeQuestion: {
    getAll: "/establishment-type-question/getAll",
    create: "/establishment-type-question/create",
    update: "/establishment-type-question/update",
    delete: "/establishment-type-question/delete",
    reorder: "/establishment-type-question/reorder",
  },

  // Shipping Box Type endpoints
  shippingBox: {
    getAll: "/shipping-box/getAll",
    create: "/shipping-box/create",
    update: "/shipping-box/update",
    delete: "/shipping-box/delete",
  },

  // Location endpoints
  location: {
    getCountries: "/location/getCountries",
    getStates: "/location/getStates",
    getCities: "/location/getCities",
    getAll: "/location/getAll",
    create: "/location/create",
    update: "/location/update",
    delete: "/location/delete",
  },

  // Email Template endpoints
  emailTemplate: {
    getAll: "/email-template/getAll",
    postMailToLostItemUser: "/email-template/postMailToLostItemUser",
    create: "/email-template/create",
    update: "/email-template/update",
    delete: "/email-template/delete",
    getEmailContext: "/email-template/getEmailContext",
    updateOrder: "/email-template/updateOrder",
    getNotPaidClaims: "/email-template/getNotPaidClaims",
    sendBulkCustomEmail: "/email-template/sendBulkCustomEmail",
  },

  sticky: {
    getAll: "/sticky/getAll",
    create: "/sticky/create",
    update: "/sticky/update",
  },

  // Activity Log endpoints
  activityLog: {
    getAllLostItemLogs: "/activity-log/getAllLostItemLogs",
    getAllFoundItemLogs: "/activity-log/getAllFoundItemLogs",
    createNoteByAdmin: "/activity-log/createNoteByAdmin",
    updateNoteByAdmin: "/activity-log/updateNoteByAdmin",
    createNoteByAdminForFound: "/activity-log/createNoteByAdminForFound",
    updateNoteByAdminForFound: "/activity-log/updateNoteByAdminForFound",
    getAllActivityLogs: "/activity-log/getAllActivityLogs",
    getAllEmailLogs: "/activity-log/getAllEmailLogs",
    getAllPaymentLogs: "/activity-log/getAllPaymentLogs",
    getEmailBody: "/activity-log/email-body"
  },

  // Carrier endpoints
  carrier: {
    getAll: "/carrier/getAll",
  },

  // Courier endpoints
  courier: {
    getAll: "/courier/getAll",
    create: "/courier/create",
    update: "/courier/update",
    delete: "/courier/delete",
  },

  // Courier Shipping Options endpoints
  courierShippingOptions: {
    getAll: "/courier-shipping-option/getAll",
    create: "/courier-shipping-option/create",
    update: "/courier-shipping-option/update",
    delete: "/courier-shipping-option/delete",
  },

  //Shipping Option endpoints
  shippingOption: {
    getAll: "/shipping-options/getAll",
    update: "/shipping-options/update",
    createPrematchData: "/shipping-options/createPrematchData",
    getPackage: "/shipping-options/getPackage",
    updatePackage: "/shipping-options/updatePackage",
    updateShippingOptionAddress: "/shipping-options/updateShippingOptionAddress",
    clone: "/shipping-options/clone",
  },

  //Pricing Configuration
  pricingConfig: {
    getAll: "/pricing-config/getAll",
    create: "/pricing-config/create",
    update: "/pricing-config/update",
  },

  // Scheduler Settings
  schedulerSettings: {
    getLostSchedulerInterval: "/lost/getLostSchedulerInterval",
    updateLostSchedulerInterval: "/lost/updateLostSchedulerInterval",
    runUnpaidCleanupNow: "/lost/runUnpaidCleanupNow",
    runReviewToInProcessNow: "/lost/runReviewToInProcessNow",
  },

  //Ship From Port endpoints
  shipFromPort: {
    getAll: "/ship-from-port/getAll",
    create: "/ship-from-port/create",
    update: "/ship-from-port/update",
    delete: "/ship-from-port/delete",
  },

  // Establishment endpoints
  establishment: {
    get: "/establishment/get",
    update: "/establishment/update",
  },

  // Whiteboard endpoints
  whiteboard: {
    getAll: "/whiteboard/getAll",
    create: "/whiteboard/create",
    update: "/whiteboard/update",
    delete: "/whiteboard/delete",
    updateOrder: "/whiteboard/updateOrder",
  },

  //Payment Configuration
  payment: {
    getPaymentDueDays: "/payment/getAllPaymentDueDays",
    createPaymentDueDays: "/payment/createPaymentDueDays",
    updatePaymentDueDays: "/payment/updatePaymentDueDays",
  },

  // PayPal SDK Version
  paypalSdk: {
    getVersion: "/paypal/v6/sdk-version",
    updateVersion: "/paypal/v6/sdk-version",
  },

  //Item Columns
  itemColumns: {
    getAll: "/item-columns/getAll",
    create: "/item-columns/create",
    update: "/item-columns/update",
  },

  //Language Configuration
  languageConfig: {
    getAll: "/language-config/getAll",
    update: "/language-config/update",
  },

  // Campaign endpoints
  campaign: {
    getAll: "/campaign/getAll",
    create: "/campaign/create",
    update: "/campaign/update",
    delete: "/campaign/delete",
  },

  // Admin Session endpoints
  adminSession: {
    getUserSessions: "/admin-session/user",
    approve: "/admin-session",
    disapprove: "/admin-session",
    revoke: "/admin-session",
  },
};
